import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import { GetUserSubscriptionDetails } from '../apiconstants/constants';
import { Modal, Button } from 'react-bootstrap';

const SubscriptionHistory = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [selectedSub, setSelectedSub] = useState(null);
  const [showModal, setShowModal] = useState(false);
const token = localStorage.getItem("jwtToken");
  useEffect(() => {
    const userGuid = localStorage.getItem("guid");

    if (!userGuid) {
      console.warn("No GUID found in localStorage");
      return;
    }

    const fetchSubscriptionHistory = async () => {
      try {
        const response = await axios.get(`${GetUserSubscriptionDetails.APIURL}?UserGuid=${userGuid}`,
        { headers: {
          Authorization: `Bearer ${token}`,
        }
      }
        );
        setSubscriptions(response.data);
      } catch (error) {
        console.error('Error fetching subscription history:', error);
      }
    };

    fetchSubscriptionHistory();
  }, []);

  const handleMoreDetails = (subscription) => {
    setSelectedSub(subscription);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedSub(null);
  };

  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
        <h2 style={{ color: "#00a7ac", marginLeft: '10px' }}>Subscription History</h2>
        <hr style={{ border: 'none', borderTop: '1px solid #f3f3f3', margin: '10px 0' }} />

        <div className="table-responsive mt-5">
          <table className="table table-striped table-bordered table-hover">
            <thead style={{ backgroundColor: '#00a7ac', color: 'white' }}>
              <tr>
                <th>Type</th>
                <th>Status</th>
                <th>Amount</th>
                <th>Payment Date</th>
                <th>Next Billing</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {subscriptions.length === 0 ? (
                <tr><td colSpan="6" className="text-center">No subscription history found.</td></tr>
              ) : (
                subscriptions.map((sub) => (
                  <tr key={sub.subscriptionID}>
                    <td>{sub.durationType}</td>
                    <td><span className={`badge ${sub.status === 'succeeded' ? 'bg-success' : 'bg-danger'}`}>{sub.status}</span></td>
                    <td>${sub.price}</td>
                    <td>{new Date(sub.createdDate).toLocaleString()}</td>
                    <td>{sub.endDate ? new Date(sub.endDate).toLocaleDateString() : 'N/A'}</td>
                    <td>
                      <Button variant="info" size="sm" onClick={() => handleMoreDetails(sub)}>More Details</Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Modal for details */}
        <Modal show={showModal} onHide={closeModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Subscription Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedSub && (
              <div>
                <p><strong>Full Name:</strong> {selectedSub.fullName}</p>
                <p><strong>Email:</strong> {selectedSub.email}</p>
                <p><strong>Plan Name:</strong> {selectedSub.planName}</p>
                <p><strong>Duration Type:</strong> {selectedSub.durationType}</p>
                <p><strong>Status:</strong> {selectedSub.status}</p>
                <p><strong>Card Brand:</strong> {selectedSub.card_brand}</p>
                <p><strong>Card Last 4 Digits:</strong> {selectedSub.card_last4}</p>
                <p><strong>Amount:</strong> ${selectedSub.price} {selectedSub.currency}</p>
                <p><strong>Start Date:</strong> {new Date(selectedSub.startDate).toLocaleDateString()}</p>
                <p><strong>End Date:</strong> {new Date(selectedSub.endDate).toLocaleDateString()}</p>
                <p><strong>Payment Date:</strong> {new Date(selectedSub.createdDate).toLocaleString()}</p>
                <a href={selectedSub.receipt_url} target="_blank" rel="noopener noreferrer" className="btn btn-primary mt-2">View Receipt</a>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </ConsultantLayout>
  );
};

export default SubscriptionHistory;
